import { Observable } from "rxjs";

import st from "lib/utils/index";
import { CompanyRepository } from "lib/repositories/index";
import { createFormInstance } from "modules/utils/index";
import { fetchCurrentCompany } from "modules/auth";

export const INITIALIZE_VIEW = "settings/MarketplaceSettingsView/INITIALIZE_VIEW";
export const INITIALIZE_MODEL = "settings/MarketplaceSettingsView/INITIALIZE_MODEL";
export const UPDATE_MODEL = "settings/MarketplaceSettingsView/UPDATE_MODEL";
export const VALIDATE = "settings/MarketplaceSettingsView/VALIDATE";
export const SUBMIT = "settings/MarketplaceSettingsView/SUBMIT";
export const FETCH_SUBMIT_START = "settings/MarketplaceSettingsView/FETCH_SUBMIT_START";
export const FETCH_SUBMIT_SUCCESS = "settings/MarketplaceSettingsView/FETCH_SUBMIT_SUCCESS";
export const FETCH_SUBMIT_FAILURE = "settings/MarketplaceSettingsView/FETCH_SUBMIT_FAILURE";

export const stateSelector = (state) => state.settings.MarketplaceSettingsView;

const formInstance = createFormInstance({
  INITIALIZE_MODEL,
  UPDATE_MODEL,
  VALIDATE,
  SUBMIT,
  FETCH_SUBMIT_START,
  FETCH_SUBMIT_SUCCESS,
  FETCH_SUBMIT_FAILURE,
  stateSelector,
  validate: ({ form: { model } }, errors) => {
    // errors.add(`model.name`, st.validators.presence(model.name))
  },
  submitModel: ({ form: { initialModel, model } }) => {
    const serialize = (company) => ({
      id: company.id,
      marketplace_cover_image: company.marketplace_cover_image,
      translations: company.translations.map((t) => ({
        id: t.id,
        locale: t.locale,
        marketplace_name: t.marketplace_name,
        marketplace_short_description: t.marketplace_short_description,
      })),
    });
    return CompanyRepository.update(serialize(model), serialize(initialModel), { useFormData: true });
  },
});

const initialState = {
  form: formInstance.initialState,
};

const reducers = {
  ...formInstance.reducersMap,

  [INITIALIZE_VIEW]: () => initialState,
};

const epics = [
  ...formInstance.epics,

  (actions$, { getState }) =>
    actions$.ofType(INITIALIZE_VIEW).map(() => {
      const company = getState().auth.company.model;
      return initializeModel(company);
    }),

  (actions$) => actions$.ofType(FETCH_SUBMIT_SUCCESS).mapTo(fetchCurrentCompany()),
];

export function initializeView() {
  return { type: INITIALIZE_VIEW };
}

export const { initializeModel, updateModel, validate, submit } = formInstance.actions;

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/settings/MarketplaceSettingsView/index.js